const CERTIFICATIONS = [
  {
    abbr: "ISO",
    title: "ISO 9001:2015",
    body: "Quality Management System",
    description: "Certified for consistent delivery of quality electrical and MEP services meeting international standards.",
  },
  {
    abbr: "NSIC",
    title: "NSIC Registered",
    body: "National Small Industries Corporation",
    description: "Empanelled with NSIC, enabling eligibility for government tenders and public sector contracts across India.",
  },
  {
    abbr: "MSME",
    title: "MSME Registered",
    body: "Ministry of MSME, Govt. of India",
    description: "Officially registered under the MSME Development Act, recognised by the Government of India.",
  },
  {
    abbr: "PF",
    title: "EPF & ESIC Compliant",
    body: "Labour Law Compliance",
    description: "Fully compliant with Employees' Provident Fund and Employee State Insurance Corporation regulations.",
  },
  {
    abbr: "GST",
    title: "GST Registered",
    body: "Goods & Services Tax",
    description: "Registered under the Goods and Services Tax framework, ensuring transparent and compliant billing.",
  },
  {
    abbr: "EL",
    title: "Electrical Contractor License",
    body: "State Electricity Boards",
    description: "Licensed electrical contractor authorized to undertake HT/LT electrical works across multiple states.",
  },
];

export default function Certifications() {
  return (
    <section
      aria-labelledby="certifications-heading"
      className="bg-gray-50 py-20 px-6 border-t border-gray-100"
    >
      <div className="max-w-7xl mx-auto">

        {/* Heading */}
        <div className="text-center mb-14">
          <p className="text-orange-500 uppercase tracking-widest text-sm font-semibold mb-2">
            Compliance & Credibility
          </p>
          <h2
            id="certifications-heading"
            className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight"
          >
            Certifications & Accreditations
          </h2>
          <p className="mt-4 text-gray-500 max-w-2xl mx-auto text-base md:text-lg">
            Our credentials reflect our commitment to quality, compliance and operational excellence across every project we undertake.
          </p>
        </div>

        {/* Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {CERTIFICATIONS.map((cert) => (
            <div
              key={cert.title}
              className="flex items-start gap-5 bg-white border border-gray-100 rounded-2xl p-7 shadow-sm hover:shadow-md transition-shadow duration-300"
            >
              {/* Badge */}
              <div className="shrink-0 w-14 h-14 rounded-xl bg-orange-50 border border-orange-100 flex items-center justify-center">
                <span className="text-orange-500 font-extrabold text-xs tracking-tight text-center leading-tight px-1">
                  {cert.abbr}
                </span>
              </div>

              {/* Text */}
              <div>
                <h3 className="text-gray-900 font-semibold text-base leading-snug">
                  {cert.title}
                </h3>
                <p className="text-orange-500 text-xs font-medium mt-0.5 mb-2">
                  {cert.body}
                </p>
                <p className="text-gray-500 text-sm leading-relaxed">
                  {cert.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Trust strip */}
        <div className="mt-14 flex flex-wrap items-center justify-center gap-x-10 gap-y-4 text-gray-400 text-sm font-medium">
          {[
            "Pan-India Operations",
            "18+ Years in Industry",
            "Government Empanelled",
            "100+ Projects Delivered",
            "Zero Compromise on Safety",
          ].map((item) => (
            <span key={item} className="flex items-center gap-2">
              <span className="w-1.5 h-1.5 rounded-full bg-orange-400 inline-block" />
              {item}
            </span>
          ))}
        </div>

      </div>
    </section>
  );
}
